import { useTranslation } from 'react-i18next';

import { useUiVersion, UI_V1, UI_V2 } from 'hooks';
import { Segmented, Option } from './ui-version-switch.styled';

/**
 * Lets the user switch between the new CleverParking redesign and the classic
 * (legacy) UI. Choice is persisted (see `useUiVersion`).
 *
 * @param {boolean} onDark  style for placement over a dark surface (login).
 */
export const UiVersionSwitch = ({ onDark = false }) => {
  const { t } = useTranslation();
  const { version, setVersion } = useUiVersion();

  return (
    <Segmented $onDark={onDark} role="group" aria-label="Версия интерфейса">
      <Option type="button" $onDark={onDark} $active={version === UI_V2} onClick={() => setVersion(UI_V2)}>
        {t('ui.new')}
      </Option>
      <Option type="button" $onDark={onDark} $active={version === UI_V1} onClick={() => setVersion(UI_V1)}>
        {t('ui.classic')}
      </Option>
    </Segmented>
  );
};
